<template>
  <div class="grid meeting-agenda">
    <div v-if="loaders.agendas" class="loading-indicator"><MoonLoader size="75px" color="#ffffff"></MoonLoader></div>
    <div class="grid">
      <div class="grid__col--12 meeting-agenda__title h-center-align">Meeting Agendas</div>
    </div>
    <MeetingAgendasContainer></MeetingAgendasContainer>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { MoonLoader } from 'vue-spinner/dist/vue-spinner.min.js';
  import MeetingAgendasContainer from '../meeting-agendas/MeetingAgendasContainer.vue';

  export default {
    name: 'MeetingAgendasLayout',
    components: {
      MoonLoader,
      MeetingAgendasContainer,
    },
    computed: {
      ...mapGetters('meetingAgendas', ['loaders', 'autoFetchCommentsTimeout']),
    },
    mounted() {
      this.$store.dispatch('main/setProperty', { key: 'globalLoading', value: false });
    },
  };
</script>
